type ProductRefLike = {
  productId: string
  cloudMarketplaceProductId?: string
}

const findProductByProductRef = <T extends ProductRefLike>(
  products: T[],
  productRef?: string
): T | undefined => {
  if (!productRef) {
    return undefined
  }

  return products.find(
    product =>
      product.productId === productRef ||
      product.cloudMarketplaceProductId === productRef
  )
}

export const resolveLabraProductIdForPrivateOfferNavigation = <
  T extends ProductRefLike,
>({
  products,
  selectedProductId,
  offerProductRef,
}: {
  products: T[]
  selectedProductId?: string
  offerProductRef?: string
}): string => {
  if (selectedProductId) {
    const selectedProduct = findProductByProductRef(products, selectedProductId)
    if (selectedProduct) {
      return selectedProduct.productId
    }
  }

  if (offerProductRef) {
    return (
      findProductByProductRef(products, offerProductRef)?.productId ||
      offerProductRef
    )
  }

  return selectedProductId || ''
}
